import { defineAbility } from "@casl/ability";

export const ability = defineAbility(() => []); // По умолчанию запрещаем всё

export function updateAbility(newRules: any) {
  ability.update(newRules);
}
